import classnames from 'classnames'
import React from 'react'
import type { PropsWithChildren, FC } from 'react'

import styles from './CardFooter.module.css'

type Props = {
  noBackground: boolean
}
const Container: FC<PropsWithChildren<Props>> = ({
  children,
  noBackground
}) => {
  return (
    <div
      className={classnames(
        styles.Container,
        noBackground && styles.NoBackground
      )}
      data-testid='card-footer'
    >
      {children}
    </div>
  )
}

const Content: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.Content} data-testid='card-footer-content'>
      <div className={styles.ContentEllipsis}>{children}</div>
    </div>
  )
}

const Actions: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.ActionsList} data-testid='card-footer-actions'>
      {children}
    </div>
  )
}

const ActionItem: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.ActionItem} data-testid='card-footer-item'>
      {children}
    </div>
  )
}

export default {
  Container,
  Content,
  Actions,
  ActionItem
}
